import { render, staticRenderFns } from "./BankFeeMarkup.vue?vue&type=template&id=7315275a&"
import script from "./BankFeeMarkup.vue?vue&type=script&lang=js&"
export * from "./BankFeeMarkup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/BankFeeMarkup.vue
// module id = null
// module chunks = 